module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"all":"所有类别"},"en":{"all":"All Collections"},"jp":{"all":"すべてのカテゴリ"},"fr":{"all":"Toutes les Collections"},"de":{"all":"Alle Sammlungen"},"es":{"all":"Todas las Colecciones"},"pt":{"all":"Todas as coleções"},"it":{"all":"Tutte le Collezioni"},"tw":{"all":"所有類別"},"kr":{"all":"모든 컬랙션"},"id":{"all":"Semua Koleksi"}}')
  delete Component.options._Ctor
}
